const CloudCompleted = props => (
  <svg width="21" height="16" viewBox="0 0 21 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="completed">
      <path
        id="checkmark.icloud"
        d="M15.7188 15.0391H4.89844C2.125 15.0391 0 13.0156 0 10.5859C0 8.60156 1.10938 6.97656 2.91406 6.63281C3.00781 4.42188 5.08594 2.9375 7.10938 3.44531C8.11719 2 9.70312 0.960938 11.7656 0.960938C15.0859 0.960938 17.6562 3.53125 17.6562 7.09375C19.2188 7.74219 20.1719 9.25 20.1719 10.9297C20.1719 13.2109 18.2031 15.0391 15.7188 15.0391Z"
        fill="white"
      />
      <g id="Black-S">
        <path
          id="Vector"
          d="M9.32928 12.2449C8.95746 12.2449 8.66169 12.059 8.41663 11.7801L6.98003 10.1323C6.76877 9.8872 6.70117 9.70127 6.70117 9.45621C6.70117 8.92384 7.14905 8.50976 7.67298 8.50976C7.96875 8.50976 8.18845 8.63651 8.38283 8.84777L9.32928 9.90409L11.6278 6.30416C11.8644 5.94079 12.1264 5.75488 12.4813 5.75488C13.0053 5.75488 13.47 6.15205 13.47 6.676C13.47 6.8619 13.4193 7.07317 13.2672 7.28443L10.225 11.7548C10.0138 12.0505 9.6842 12.2449 9.32928 12.2449Z"
          fill="#0DB08C"
        />
      </g>
    </g>
  </svg>
)

export default CloudCompleted
